import styled from 'styled-components'

export const MemberIcon = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 999px;
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  font-size: 0.75rem;
  text-transform: uppercase;

  border: 1px solid ${({ theme }) => theme.colors.foreground.primary.A};

  background-color: ${({ theme }) => theme.colors.inspect.guide};
  color: ${({ theme }) => theme.colors.foreground.primary.A};
`

export const MemberIconGroup = styled.div`
  width: 28px;
  height: 28px;

  display: flex;
  align-items: center;
  position: relative;

  ::after,
  ::before {
    content: '';
    position: absolute;
    border-radius: 999px;
    top: 0;
    left: 0;
    width: 28px;
    height: 28px;
    background-color: ${({ theme }) => theme.colors.inspect.guide};
    border: 1px solid ${({ theme }) => theme.colors.foreground.primary.A};
  }

  :after {
    transform: translate3d(2px, 2px, 0);
  }

  :before {
    transform: translate3d(4px, 4px, 0);
  }
`

export const TextWrapper = styled.div`
  margin-left: 12px;
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`
